import { css } from '@lastbrand/web-ui-styled-system/css'

export const containerCss = css({
  position: 'relative',
  width: 'full',
  transition: 'all 0.2s ease-in-out',
})

export const iframeCss = css({
  width: 'full',
  border: 'none',
  transition: 'all 0.2s ease-in-out',
  height: '52px',
})

export const loaderContainerCss = css({
  display: 'flex',
  gap: 'space-12',
  position: 'absolute',
  top: 0,
  left: 0,
  width: 'full',
  bg: 'white',
})

export const loaderSkeletonCss = css.raw({
  borderRadius: 'radius-round',
  width: 'full',
  height: '52px',
})

export const loaderSkeletonSecondaryCss = css.raw({
  width: 'full',
  borderRadius: 'radius-round',
  height: '50px',
})

export const paymentOverlayCss = css({
  position: 'fixed',
  height: '100vh',
  width: '100vw',
  bg: 'white',
  top: 0,
  left: 0,
  zIndex: 9999,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
})

export const paymentOverlayTitleCss = css({
  textStyle: 'body-16',
  color: 'black',
  mb: 'space-8',
})

export const paymentOverlayDescriptionCss = css({
  textStyle: 'body-14',
})
